﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconClipboardList } from "@tabler/icons-react";

export const TiposDocumentoIcon = IconClipboardList;
export const TiposDocumentoHelpText = '* Aquí puede ver los diferentes tipos de documento asignables por empleado.';

export class catTiposDocumento extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDocumento";
        this.def.columns.c_category_id.defaultValue = "TiposDocumento";
        this.Title = "Tipos de Documento";
        this.HelpText = TiposDocumentoHelpText;
        this.Icon = TiposDocumentoIcon;
    }
}